import { render, staticRenderFns } from "./ClientPreferenceResultsView.vue?vue&type=template&id=3aa904f0&scoped=true&"
import script from "./ClientPreferenceResultsView.vue?vue&type=script&lang=js&"
export * from "./ClientPreferenceResultsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa904f0",
  null
  
)

export default component.exports